<script>
  export let references;
</script>

<style>
  .references {
    max-width: 800px;
    margin: 0 auto;
    padding: 1.5rem;
  }

  h4 {
    font-size: 1.6rem;
    margin: 1.5rem 0 1rem 0;
  }

  ul {
    margin-left: 2rem;
  }

  li {
    font-size: 1.3rem;
    font-weight: 300;
    margin: 1rem 0;
    overflow-wrap: break-word;
  }
</style>

<section class="references">
  <h4>อ้างอิง</h4>
  <ul>
    {#each references as reference}
      <li>
        {@html reference}
      </li>
    {/each}
  </ul>
</section>
